const ReasonSection = () => {
  const reasons = [
    {
      title: "虫歯",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_reason01.jpg",
      description: "虫歯で歯がぼろぼろになってしまうと、健康な部分が少なくなり、土台として使うのが難しくなってしまいます。虫歯を全て取り去った後、残った部分が噛む力に耐えきれないと判断された場合は、歯を残しておくと虫歯菌が増殖する原因となってしまうため、抜歯が必要となります。"
    },
    {
      title: "歯周病",
      image: "https://www.masu-dc.or.jp/lp-implant/img/pic_reason02.jpg",
      description: "歯を失う理由の第1位は歯周病です。歯周病は歯茎の腫れにはじまり、最終的には骨を溶かす恐ろしい病気です。歯周病が口腔内に存在すると、どんな治療も上手くいきません。家を建てる時の地盤や基礎のようなもので、インプラント治療においても、治療開始時には、治った状態であることが必要です。"
    },
    {
      title: "噛み合わせ",
      image: "https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/618da661a634b69f772d9842082b5ace.png",
      description: "不適切な被せ物や詰め物、顎の発達と歯の大きさの不調和などにより、噛み合わせに不具合が生じることがあります。痛みがあるだけでなく、過度な力が加わることによって、歯が折れてしまうこともあります。また、局所的に骨が溶けてしまい、抜けてしまうことも考えられます。"
    }
  ];

  return (
    <section className="py-20 bg-[#f5f1e8] relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2c5f7c] mb-6">
            今まで考えたことがありますか？<br />
            「歯がなくなる理由」を
          </h2>
        </div>

        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-[#c8a882] mb-8">
            歯がなくなる理由 ワースト3
          </h3>
        </div>

        {/* Reasons List */}
        <div className="space-y-12 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center bg-white rounded-2xl p-8 shadow-lg`}
            >
              <div className="lg:w-1/2">
                <img
                  src={reason.image}
                  alt={reason.title}
                  className="w-full h-64 object-cover rounded-xl"
                />
              </div>
              
              <div className="lg:w-1/2 space-y-4">
                <div className="inline-block">
                  <div className="bg-[#2c5f7c] text-white px-6 py-2 rounded-lg font-bold text-xl">
                    {reason.title}
                  </div>
                </div>
                
                <p className="text-gray-700 leading-relaxed text-lg">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="text-center mt-16">
          <div className="bg-[#2c5f7c] rounded-2xl p-8 max-w-4xl mx-auto">
            <p className="text-2xl font-bold text-white">
              ゆうまデンタルクリニックは<br />
              歯のなくなる原因と戦います！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReasonSection;
